import React, { useContext, useEffect, useState } from "react";
import classes from "./Services.module.css";
import AuthContext from "../../store/auth-context";
import Helpers from "../../utils/Helpers";
import { useNavigate } from "react-router-dom";
import { images } from "../../assets/img";
import RemoteConfig from "../../services/RemoteConfig";
import BookNowBtn from "../BookNowBtn";
import "../../index.css";
import MainCarousel from "../Carousel/Carousel";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

const SERVICES = [
  {
    image: images.nail03,
    title: "Pedicure",
    description: "Pedicure (Warm feet with mint mineral salts, dried roses, orange, rose oil, nail shape and cuticle care, remove hard skin and dead skin, scrub with coffee or matcha powder, good massage with matxa roller and  Good smell cream, hot towel, moisturized foot mask, complete the nail set with your choice color ,great relaxation and health)",
  },
  {
    image: images.banner02,
    title: "Manicure",
    description: "Manicure (Soak your hands with orange minerals, dried roses, and essential oils in roses.  Nail shape and cuticle care , dead skin removal, professional hand massage, moisturizing hand mask and hot towels.  Finish with favorite colors along with a soft and beautiful hand",
  },
  {
    image: images.nail05,
    title: "BIAB (Builder in a Bottle)",
    description: "BIAB is a soak-off builder gel that’s applied like regular gel polish but cures to form a tough, resilient layer, perfect for reinforcing natural nails or creating natural-looking overlays. It’s ideal for clients who want to grow their own nails or need extra protection without committing to acrylics.\nBIAB is a soak-off builder gel that’s applied like regular gel polish but cures to form a tough, resilient layer, perfect for reinforcing natural nails or creating natural-looking overlays.",
  },
  {
    image: images.nail06,
    title: "Acrylic",
    description: "Acrylic nails are a timeless and highly versatile choice for those seeking long-lasting, beautifully sculpted enhancements. Created by blending a liquid monomer with a powder polymer, acrylic forms a hard protective layer over your natural nails, offering exceptional strength and durability. This makes them ideal for clients who love extended length or bold shapes such as stiletto, coffin, or almond.",
  },
  {
    image: images.nail03,
    title: "Nails Design",
    description: "Nail Art isn’t just a service — it’s a form of self-expression. We specialise in custom designs tailored to your personal style, inspired by the latest global trends, seasonal vibes, and your own creative vision. Whether you’re after something minimalist, playful or elegant, our talented nail artists are always up-to-date with the hottest looks and techniques. From intricate hand-painted details to 3D embellishments and on-trend colour palettes, every set is designed with precision and passion.",
  },
];


const Services = (props) => {
  const navigate = useNavigate();
  const isMobile = useCheckIsMobile();

  const renderServices = () => {
    function chunkArray(arr, chunkSize) {
      const result = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize));
      }
      return result;
    }

    const chunkedServiceArray = chunkArray(SERVICES, isMobile ? 1 : 3);

    return chunkedServiceArray.map((serviceGroup, index) => {
      return (
        <div className={classes.servicesRow} key={`service-${index}`}>
          {serviceGroup.map(({ title, description, image }, index) => {
            return (
              <div className={classes.serviceItem} key={`${index}-${title}`}>
                <div
                  style={{
                    borderTopLeftRadius: "100%",
                    borderTopRightRadius: "100%",
                    borderWidth: "1px",
                    borderColor: "red",
                    padding: "1px",
                    backgroundColor: "#000",
                  }}
                >
                  <img className={classes.serviceImg} alt={title} src={image} />
                </div>

                <div className={classes.serviceItemTextContainer}>
                  <h2>{title}</h2>
                  <h4>{description}</h4>
                </div>
              </div>
            );
          })}
        </div>
      );
    });
  };

  return (
    <div ref={props?.serviceRef} className={classes.wrapper}>
      <h1 className={classes.title}>Our Services</h1>

      <MainCarousel>{renderServices()}</MainCarousel>

      <BookNowBtn
        style={classes.priceListBtn}
        onClick={() => navigate("/services")}
        title={"VIEW PRICING"}
      />
    </div>
  );
};

export default Services;
